var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F79AA6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.67,
    d: "m2 21.5 7.452-7.452a3.25 3.25 0 0 1 4.596 0L21.5 21.5m-3.25-3.25 2.577-2.577a3.25 3.25 0 0 1 4.596 0L28 18.25M18.25 8.5h.016M5.25 28h19.5A3.25 3.25 0 0 0 28 24.75V5.25A3.25 3.25 0 0 0 24.75 2H5.25A3.25 3.25 0 0 0 2 5.25v19.5A3.25 3.25 0 0 0 5.25 28Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMedia);
export default __webpack_public_path__ + "static/media/uploadMedia.9b9a4b27fa0430e16380dabf7242c981.svg";
export { ForwardRef as ReactComponent };